import React from "react";
import "../../styles/default.css";
import "../../styles/responsive.css";

function Footer() {
  return (
    <footer>
      <div className="topfoot">
        {/* Logo and Social Media Section */}
        <section className="scOne">
          <div className="footlog">
            <div className="iblotec_logo">
              <img src="images/iblotec logobw.png" alt="IBloTech Logo" />
            </div>
            <span className="iblotec_name head" style={{ opacity: 1 }}>
              <span className="iblo">IBlo</span>{" "}
              <span className="tec">Tec</span>
            </span>
          </div>
          <small>IBlotec 2026 all rights reserved</small>
          <div className="social">
            <a href="https://www.facebook.com/iblotec21?mibextid=rS40aB7S9Ucbxw6v">
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/iblotecafrica?igsh=MWxvb3ZuZnNibmNwdw==">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=+25768045157&text=Inquire"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <a href="mailto:support@iblotec.africa">
              <i className="fa-solid fa-envelope"></i>
            </a>
          </div>
        </section>

        {/* Services Section */}
        <section className="scTwo">
          <div className="titfoot">Services</div>
          <a href="/market">Market</a>
          <a href="/school">School</a>
        </section>

        {/* Address Section */}
        <section className="scThree">
          <div className="titfoot">Address</div>
          <span>
            <i className="fa-solid fa-location-dot"></i>
            Burundi ► Bujumbura ► KABONDO ► Avenue du 13 Octobre ►
            <span className="iblo"> No.18</span>
          </span>
          <span>
            <i className="fa-solid fa-envelope"></i> support@iblotec.africa
          </span>
          <span>
            <i className="fa-solid fa-phone"></i> +257 68045157
          </span>
        </section>
      </div>

      {/* Bottom Footer Section */}
      <div className="botfoot">
        ©copyright iblotec |<a href="privacy"> Privacy Policy/ Terms User</a> /
        Data Treatment / Accessibility
      </div>
    </footer>
  );
}

export default Footer;
